export { default as delayWeWantToPayModal } from './delayOpen';
export { default as openWeWantToPayModal } from './openOnActions';

// openModal  :: local action (triggers middleware)
// OPEN_MODAL :: ModalsLogic action (actually opens modal)

// closeModal  :: local action (triggers middleware)
// CLOSE_MODAL :: ModalsLogic action (actually closes modal)

// LOGIN          -> if <conditions> -> openModal
// Modal.didMount -> openModal
// openModal      -> if <conditions & time> -> OPEN_MODAL
// cloaseModal    -> CLOSE_MODAL & openModal
